export default "__VITE_ASSET__DjP81oqW__"